import { render, staticRenderFns } from "./cadastroEstudantes.vue?vue&type=template&id=723a7ce2&scoped=true&"
import script from "./cadastroEstudantes.vue?vue&type=script&lang=js&"
export * from "./cadastroEstudantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723a7ce2",
  null
  
)

export default component.exports